// extracted by mini-css-extract-plugin
export default {"carouselItem":"styles_carouselItem__BUzI5","carouselItemPlaying":"styles_carouselItemPlaying__2Hpq5"};